import {SetGetViewExchangeRates} from './thunk/setGetViewExchangeRates';
import {SetGetListExchangeRates} from './thunk/setGetListExchangeRates';
import {SetPostCreateExchangeRates} from './thunk/setPostCreateExchangeRates';
import {SetPostUpdateExchangeRates} from './thunk/setPostUpdateExchangeRates';

export const Thunks = {
    SetGetListExchangeRates,
    SetGetViewExchangeRates,
    SetPostCreateExchangeRates,
    SetPostUpdateExchangeRates
}